<script setup lang="ts">
const props = defineProps({
  sideCateDisplay: { type: Boolean, default: false},
  contTitle: { type: String, default: "最新の記事", required: false }
});
</script>

<template>
  <div class="side-contents">
    <section v-show="sideCateDisplay" class="side-cate">
      <h2><span>カテゴリーで調べる</span></h2>
      <OrganismsSmallCateList />
    </section>
    <OrganismsSmallContList :contTitle="contTitle" />
    <OrganismsSideRequest />
    <!-- <OrganismsSideAnotherLink /> -->
  </div>
</template>

<style lang="scss" scoped>
.side-cate {
  padding: 0 0 8%;
}

.side-cate h2 {
  margin: 0 4%;
  padding: 0.5em;
  color: #1e86c6;
  background-color: #e6e6e6;
  text-align: center;
  font-weight: bold;
}

@media screen and (min-width: 751px) {
  .side-contents {
    width: 290px;
  }
  .side-cate {
    padding: 0 0 30px;
  }
  .side-cate h2 {
    margin: 0;
    font-size: 146%;
  }
}
</style>
